import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import IsError from 'iserror';

import config from '../config/config.json';

const bugsnagKey = config.BUGSNAG_API_KEY;
let bugsnagClient;

if (bugsnagKey !== undefined) {
  bugsnagClient = Bugsnag.start({
    apiKey: bugsnagKey,
    plugins: [new BugsnagPluginReact(React)],
    appType: 'frontbase',
    appVersion: config.BUILD_ID,
  });
}

export const isBugsnagInitialized = () => bugsnagClient !== undefined;

export const bugsnagNotify = (exception, diagnosticData) => {
  if (!isBugsnagInitialized()) {
    return;
  }

  let err = exception;
  if (err == null) {
    err = new Error('Unknown error');
  }

  if (!IsError(err)) {
    switch (typeof exception) {
      case 'function':
        err = new Error(exception.name);
        if (typeof Error.captureStackTrace === 'function') {
          Error.captureStackTrace(err, exception.constructor);
        }
        break;

      case 'object':
        err = new Error(exception.constructor.name);
        if (typeof Error.captureStackTrace === 'function') {
          Error.captureStackTrace(err, exception.constructor);
        }
        break;

      case 'undefined':
        err = new Error('Undefined error');
        break;
      default:
        break;
    }
  }

  Bugsnag.notify(err, event => {
    if (diagnosticData) {
      const { context, user, metadata } = diagnosticData;
      if (context) {
        // eslint-disable-next-line no-param-reassign
        event.context = context;
        event.addMetadata('context', context);
      }
      if (metadata) {
        event.addMetadata('error info', metadata);
      }
      if (user) {
        const { id, email, name } = user;
        if (id) {
          event.setUser(id.toString(), email, name);
        }
      }
    }
  });
};

export const getBugsnagPlugin = () => {
  if (!isBugsnagInitialized()) {
    return null;
  }
  return Bugsnag.getPlugin('react').createErrorBoundary(React);
};

export const leaveBreadcrumb = breadcrumb => {
  if (isBugsnagInitialized()) {
    Bugsnag.leaveBreadcrumb(breadcrumb);
  }
};
